export default {
  // 新闻资讯详情接口
  getNewsDetailById: '/member/anonymous/amc/getImageTextContentById',
  // 新闻资讯相关推荐、热门评论
  getNewsOthersById: '/member/anonymous/amc/getImageTextContentOthersById',
  // 完成学习
  finishStudy: '/member/anonymous/amc/finishStudy',
  // 提交投票
  addBallotData: '/member/anonymous/amc/addBallotData',
  // 验证是否已投票
  validateHasBallotOrNotByMember: '/member/anonymous/amc/validateHasBallotOrNotByMember',
}